import React from "react"
import DeleteFilter from "../../../../assets/iconos/close.svg";
import { latest as API_URL } from "../../../../config/api";
import ReactEcharts from "echarts-for-react";
import { barChart } from "../widgets/Charts";
import Helpers, { windowsActive } from "../../../../config/Helpers";
import axios from "axios";

const postUrlLogin = API_URL + "widgets";

class AdvanceBooking extends React.Component {

    constructor(props) {
        super(props);
        this.state = {
            column_description : "REVENUE PER PAX",
            array_colors : ["#fec400", "#ff7d4d", "#ff4558", "#15d39a"],
            table_result : {
                months          : "",
                serie_30        : "",
                serie_60        : "",
                serie_90        : "",
                serie_120       : "",
                serie_120_more  : "",
                review          : "",
                totals          : {
                    tariff_adr : 0,
                    room_nights : 0,
                    reserves : 0,
                    ep : 0,
                    serie_30: {
                        tariff_adr: 0,
                        room_nights : 0,
                        percent: 0
                    },
                    serie_60: {
                        tariff_adr: 0,
                        room_nights : 0,
                        percent: 0
                    },
                    serie_90: {
                        tariff_adr: 0,
                        room_nights : 0,
                        percent: 0
                    },
                    serie_120: {
                        tariff_adr: 0,
                        room_nights : 0,
                        percent: 0
                    },
                    serie_120_more: {
                        tariff_adr: 0,
                        room_nights : 0,
                        percent: 0
                    },
                }
            }
        }
        this.getOptionTypeBar   = this.getOptionTypeBar.bind(this);
        this.getTypeValue       = this.getTypeValue.bind(this);
    }
    getTypeValue = (value) => {
        if(this.props.view_results === "room_night"){
            return value.tariff_adr;
        }else{
            return value.tariff_total;
        }
    }
    getOptionTypeBar = (chart) => {
        
        let char_keys = Object.keys(this.props.response_request);
        let legends = [], xAxis = [], series = [];
        let $self = this;
        let result
        if (char_keys.length > 0){
            result    = this.props.response_request["result"][chart];
            if(chart !== "data_adv_booking_intervals"){
                Object.keys(result).map(function(key){
                switch (key) {
                    case "legends":
                        legends = result[key];
                        break;
                
                    case "xAxis":
                        xAxis = result[key];
                        break;
                    
                    case "series":
                        series = Object.keys(result[key]).map(function(key_serie, index){
                            return {
                                name: key_serie,
                                color: $self.state.array_colors[index],
                                type: "bar",
                                data: result[key][key_serie]
                            }
                        })
                        break;
                    }
                })
            }
        }
        return barChart("180px", legends, xAxis, series, $self.props.view_results, this.props.current_year, this.props.past_year)
    }
    componentWillReceiveProps(props){
        let type_colum = props.view_results === "revenue" ? "REVENUE" : "REVENUE PER PAX";
        this.setState({
            column_description : type_colum
        })
        let char_keys = Object.keys(props.response_request);
        let $self = this;
        let result
        if (char_keys.length > 0){
            result  = props.response_request["result"]["adv_booking_month_list"]
            Object.keys($self.state.table_result).map(function(key){
                //Omitir keys 
                if(key !== "months" && key !== "totals" && key !== "years"){
                    $self.state.table_result[key] = Object.keys(result[key]).map(function(key_serie, index){
                        if(key_serie !== "room_nights" && key_serie !== "tariff_adr" &&key_serie !== "tariff_total"){
                            return <div className={"column-grid " + (index % 2 ? "row-c" : "")}>
                                { 
                                    Object.keys(result[key][key_serie]).map(function(key_value){
                                        if(key_value !== "tariff_total" && props.view_results !== "revenue"){
                                            let item = result[key][key_serie][key_value];
                                            switch (key_value) {
                                                case "percent":
                                                    item = item + "%";
                                                    break;
                                                case "tariff_adr":
                                                    item = "$" + item;
                                                    break;
                                            }
                                            return <div className={"row-grid " + key_value}>{item}</div>
                                        }else if(key_value !== "tariff_adr" && props.view_results === "revenue"){
                                            let item = result[key][key_serie][key_value];
                                            switch (key_value) {
                                                case "percent":
                                                    item = item + "%";
                                                    break;
                                                case "tariff_total":
                                                    item = "$" + item;
                                                    break;
                                            }
                                            return <div className={"row-grid " + key_value}>{item}</div>
                                        }
                                    })
                                }
                            </div>
                        }
                    });
                }else if(key === "months"){
                    $self.state.table_result[key] = Object.keys(result[key]).map( (key_serie, index) =>
                        <div className={"column-grid " + (index % 2 ? "row-c" : "")}>
                            <div className={"row-grid " + key_serie}>{result[key][key_serie]}</div>
                        </div>
                    );
                }
                else if(key === "totals"){
                    $self.state.table_result[key] = result[key];
                }
            })
        }
    }
    render() {
        return (
            <section>
                <div className={"datagrid-widget reserves-to-future"}>
                    <div className="container-fluid">
                        <div className="row header-widget">
                            <div className="col-md-12 options-widget">
                                <span className="title">BOOKING WINDOW</span>
                                
                                <span className="opt remove-widget hide">
                                    <img src={DeleteFilter} />
                                </span>
                            </div>
                        </div>
                        <div className="current-values">
                            <div className="row">
                                
                            </div>
                            <div className="row">
                                <div className="col-md-12 datagrid-list">
                                    <div className="chart">
                                        <ReactEcharts
                                            option={ windowsActive(this.props, "lead-time", "advance_booking") === true ? this.getOptionTypeBar("data_adv_booking") : {}}
                                            notMerge={true}
                                            lazyUpdate={true}
                                            theme={"theme_name"}
                                            
                                            onChartReady={this.onChartReadyCallback}
                                        />
                                    </div>
                                </div>
                            </div>
                        </div>   
                    </div>
                </div>
                <div className="row">
                    <div className="col-md-2 no-padding-left-right">
                        <div className={"datagrid-widget list-years"}>
                            <div className="container-fluid no-padding-right">
                                <div className="row header-widget no-margin-left-right">
                                    <div className="col-md-12 options-widget">
                                        <span className="title year">{this.props.current_year}</span>
                                    </div>
                                </div>
                                <div className="current-values">
                                    <div className="row no-margin-left-right">
                                        <div className="col-md-12 datagrid-list">
                                            {this.state.table_result.months}
                                            <div className={"column-grid totals"}>
                                                <div className="row-grid">TOTAL</div>
                                            </div>
                                        </div>
                                    </div>
                                </div>   
                            </div>
                        </div>
                    </div>
                    <div className="col-md-10 no-padding-left-right">
                        <div className="scroller-section">
                            <div className={"datagrid-widget list-result-nights"}>
                                <div className="container-fluid">
                                    <div className="row header-widget">
                                        <div className="col-md-12 options-widget">
                                            <span className="title">1 - 30 <small>DAYS</small></span>
                                            <span className="opt remove-widget hide">
                                                <img src={DeleteFilter} />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="current-values">
                                        <div className="row">
                                            <div className="col-md-12 head-current">
                                                <span className="row-grid tariff_total tariff_adr">{this.state.column_description}</span>
                                                <span className="row-grid room_nights">PAX</span>
                                                <span className="row-grid percent">%</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 datagrid-list">
                                                {this.state.table_result.serie_30}
                                                <div className={"column-grid totals"}>
                                                    <span className="row-grid tariff_adr tariff_total">
                                                        ${this.getTypeValue(this.state.table_result.totals.serie_30)}
                                                    </span>
                                                    <span className="row-grid room_nights">{this.state.table_result.totals.serie_30.room_nights}</span>
                                                    <span className="row-grid percent">{this.state.table_result.totals.serie_30.percent}%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>   
                                </div>
                            </div>
                            <div className={"datagrid-widget list-result-nights"}>
                                <div className="container-fluid">
                                    <div className="row header-widget">
                                        <div className="col-md-12 options-widget">
                                            <span className="title">31 - 60 <small>DAYS</small></span>
                                            <span className="opt remove-widget hide">
                                                <img src={DeleteFilter} />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="current-values">
                                        <div className="row">
                                            <div className="col-md-12 head-current">
                                                <span className="row-grid tariff_total tariff_adr">{this.state.column_description}</span>
                                                <span className="row-grid room_nights">PAX</span>
                                                <span className="row-grid percent">%</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 datagrid-list">
                                                {this.state.table_result.serie_60}
                                                <div className={"column-grid totals"}>
                                                    <span className="row-grid tariff_adr tariff_total">
                                                        ${this.getTypeValue(this.state.table_result.totals.serie_60)}
                                                    </span>
                                                    <span className="row-grid room_nights">{this.state.table_result.totals.serie_60.room_nights}</span>
                                                    <span className="row-grid percent">{this.state.table_result.totals.serie_60.percent}%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={"datagrid-widget list-result-nights"}>
                                <div className="container-fluid">
                                    <div className="row header-widget">
                                        <div className="col-md-12 options-widget">
                                            <span className="title">61 - 90 <small>DAYS</small></span>
                                            <span className="opt remove-widget hide">
                                                <img src={DeleteFilter} />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="current-values">
                                        <div className="row">
                                            <div className="col-md-12 head-current">
                                                <span className="row-grid tariff_total tariff_adr">{this.state.column_description}</span>
                                                <span className="row-grid room_nights">PAX</span>
                                                <span className="row-grid percent">%</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 datagrid-list">
                                                {this.state.table_result.serie_90}
                                                <div className={"column-grid totals"}>
                                                    <span className="row-grid tariff_adr tariff_total">
                                                        ${this.getTypeValue(this.state.table_result.totals.serie_90)}
                                                    </span>
                                                    <span className="row-grid room_nights">{this.state.table_result.totals.serie_90.room_nights}</span>
                                                    <span className="row-grid percent">{this.state.table_result.totals.serie_90.percent}%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={"datagrid-widget list-result-nights"}>
                                <div className="container-fluid">
                                    <div className="row header-widget">
                                        <div className="col-md-12 options-widget">
                                            <span className="title">91 - 120 <small>DAYS</small></span>
                                            <span className="opt remove-widget hide">
                                                <img src={DeleteFilter} />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="current-values">
                                        <div className="row">
                                            <div className="col-md-12 head-current">
                                                <span className="row-grid tariff_total tariff_adr">{this.state.column_description}</span>
                                                <span className="row-grid room_nights">PAX</span>
                                                <span className="row-grid percent">%</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 datagrid-list">
                                                {this.state.table_result.serie_120}
                                                <div className={"column-grid totals"}>
                                                    <span className="row-grid tariff_adr tariff_total">
                                                        ${this.getTypeValue(this.state.table_result.totals.serie_120)}
                                                    </span>
                                                    <span className="row-grid room_nights">{this.state.table_result.totals.serie_120.room_nights}</span>
                                                    <span className="row-grid percent">{this.state.table_result.totals.serie_120.percent}%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={"datagrid-widget list-result-nights"}>
                                <div className="container-fluid">
                                    <div className="row header-widget">
                                        <div className="col-md-12 options-widget">
                                            <span className="title">+ 120 <small>DAYS</small></span>
                                            <span className="opt remove-widget hide">
                                                <img src={DeleteFilter} />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="current-values">
                                        <div className="row">
                                            <div className="col-md-12 head-current">
                                                <span className="row-grid tariff_total tariff_adr">{this.state.column_description}</span>
                                                <span className="row-grid room_nights">PAX</span>
                                                <span className="row-grid percent">%</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 datagrid-list">
                                                {this.state.table_result.serie_120_more}
                                                <div className={"column-grid totals"}>
                                                    <span className="row-grid tariff_adr tariff_total">
                                                        ${this.getTypeValue(this.state.table_result.totals.serie_120_more)}
                                                    </span>
                                                    <span className="row-grid room_nights">{this.state.table_result.totals.serie_120_more.room_nights}</span>
                                                    <span className="row-grid percent">{this.state.table_result.totals.serie_120_more.percent}%</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className={"datagrid-widget list-result-nights-review"}>
                                <div className="container-fluid">
                                    <div className="row header-widget">
                                        <div className="col-md-12 options-widget">
                                            <span className="title">REVIEW</span>
                                            <span className="opt remove-widget hide">
                                                <img src={DeleteFilter} />
                                            </span>
                                        </div>
                                    </div>
                                    <div className="current-values">
                                        <div className="row">
                                            <div className="col-md-12 head-current">
                                                <span className="row-grid tariff_total tariff_adr">{this.state.column_description}</span>
                                                <span className="row-grid room_nights">PAX</span>
                                                <span className="row-grid reserves">E/P</span>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-12 datagrid-list">
                                                {this.state.table_result.review}
                                                <div className={"column-grid totals"}>
                                                    <span className="row-grid tariff_adr tariff_total">
                                                        ${this.getTypeValue(this.state.table_result.totals)}
                                                    </span>
                                                    <span className="row-grid room_nights">{this.state.table_result.totals.room_nights}</span>
                                                    <span className="row-grid reserves">{this.state.table_result.totals.ep}</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
        )
    }
}

export default AdvanceBooking



// WEBPACK FOOTER //
// ./src/Frontend/modules/marketing/lead-time/views/AdvanceBooking.js